const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const BOUNDARY_START = '(?<![\\p{L}\\p{N}])';
const BOUNDARY_END = '(?![\\p{L}\\p{N}])';

const buildKeywordRegExp = (keyword: string): RegExp | null => {
	const trimmed = keyword.trim();
	if (!trimmed) {
		return null;
	}
	const pattern = escapeRegExp(trimmed).replace(/\\?\s+/g, '\\s+');
	return new RegExp(`${BOUNDARY_START}${pattern}${BOUNDARY_END}`, 'iu');
};

const matchesKeyword = (text: string, keyword: string): boolean => {
	if (!text) {
		return false;
	}
	const regExp = buildKeywordRegExp(keyword);
	return regExp ? regExp.test(text) : false;
};

/**
 * Returns true when `text` contains any of `keywords` as a whole word,
 * case-insensitively. Phrases match across arbitrary whitespace runs; blank
 * keywords and empty text never match.
 */
export const matchesAnyKeyword = (
	text: string | null | undefined,
	keywords: readonly string[],
): boolean => {
	if (!text || keywords.length === 0) {
		return false;
	}
	return keywords.some((keyword) => matchesKeyword(text, keyword));
};
